
export default {
    staged_add(context, payload) {
        context.commit('staged_add', payload)
    },
    collection_add(context, payload) {
        context.commit('collection_add', payload)
    },
}
